export { buscarEscritorioPorId, clearCurrentEscritorio } from './store/crud';
export { selectCurrentEscritorio } from './store/crud/selectors';
